import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "opModal modal-wide" }
const _hoisted_2 = { class: "d-flex justify-content-between align-items-center mb-3" }
const _hoisted_3 = { class: "text-red mb-0" }
const _hoisted_4 = { class: "row g-3" }
const _hoisted_5 = { class: "col-lg-3" }
const _hoisted_6 = { class: "filters-column" }
const _hoisted_7 = { class: "form-group mb-3" }
const _hoisted_8 = { class: "form-group mb-3" }
const _hoisted_9 = { class: "form-group mb-3" }
const _hoisted_10 = { class: "form-group mb-3" }
const _hoisted_11 = { class: "form-group mb-3" }
const _hoisted_12 = { class: "form-group mb-3" }
const _hoisted_13 = { class: "form-group mb-3" }
const _hoisted_14 = { class: "col-lg-9" }
const _hoisted_15 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_16 = { class: "d-flex flex-wrap gap-2" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "table-container" }
const _hoisted_19 = { class: "table table-hover table-sm" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "d-flex justify-content-center mt-3" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = ["onClick"]
const _hoisted_25 = {
  type: "button",
  class: "btn btn-sm btn-primary"
}
const _hoisted_26 = ["onClick"]
const _hoisted_27 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_buildings = _resolveComponent("icon-buildings")!
  const _component_icon_x_circle = _resolveComponent("icon-x-circle")!
  const _component_toggler = _resolveComponent("toggler")!
  const _component_op_date = _resolveComponent("op-date")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h5", _hoisted_3, [
        _createVNode(_component_icon_buildings, {
          class: "me-2",
          style: {"width":"18px","height":"18px"}
        }),
        _createTextVNode(" " + _toDisplayString(_ctx.title), 1)
      ]),
      _createElementVNode("button", {
        class: "btn btn-sm",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }, [
        _createVNode(_component_icon_x_circle)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _cache[17] || (_cache[17] = _createElementVNode("h6", { class: "mb-3 fw-bold" }, "Filtri di ricerca", -1)),
          _createElementVNode("div", _hoisted_7, [
            _cache[10] || (_cache[10] = _createElementVNode("label", { class: "form-label small" }, "Città", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control form-control-sm",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.search.citta) = $event))
            }, null, 512), [
              [_vModelText, _ctx.search.citta]
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _cache[11] || (_cache[11] = _createElementVNode("label", { class: "form-label small" }, "Numero immobile", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control form-control-sm",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.search.numeroImmobile) = $event))
            }, null, 512), [
              [_vModelText, _ctx.search.numeroImmobile]
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _cache[12] || (_cache[12] = _createElementVNode("label", { class: "form-label small" }, "Solo cantieri", -1)),
            _createElementVNode("div", null, [
              _createVNode(_component_toggler, {
                modelValue: _ctx.search.stammobjektOnly,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.search.stammobjektOnly) = $event))
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _cache[13] || (_cache[13] = _createElementVNode("label", { class: "form-label small" }, "Indirizzo", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control form-control-sm",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.search.indirizzo) = $event))
            }, null, 512), [
              [_vModelText, _ctx.search.indirizzo]
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _cache[14] || (_cache[14] = _createElementVNode("label", { class: "form-label small" }, "Zona", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control form-control-sm",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.search.zona) = $event))
            }, null, 512), [
              [_vModelText, _ctx.search.zona]
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _cache[15] || (_cache[15] = _createElementVNode("label", { class: "form-label small" }, "Creato dal", -1)),
            _createVNode(_component_op_date, {
              class: "form-control form-control-sm",
              modelValue: _ctx.search.createdFrom,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.search.createdFrom) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _cache[16] || (_cache[16] = _createElementVNode("label", { class: "form-label small" }, "Creato al", -1)),
            _createVNode(_component_op_date, {
              class: "form-control form-control-sm",
              modelValue: _ctx.search.createdTo,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.search.createdTo) = $event))
            }, null, 8, ["modelValue"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        (_ctx.recentEstates.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _cache[18] || (_cache[18] = _createElementVNode("div", { class: "small fw-bold mb-2" }, "Ultimi immobili usati", -1)),
              _createElementVNode("div", _hoisted_16, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recentEstates, (r) => {
                  return (_openBlock(), _createElementBlock("button", {
                    type: "button",
                    class: "btn btn-sm btn-outline-primary",
                    key: r.estateId,
                    onClick: ($event: any) => (_ctx.choose(r))
                  }, _toDisplayString(r.description), 9, _hoisted_17))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("table", _hoisted_19, [
              _cache[20] || (_cache[20] = _createElementVNode("thead", { class: "table-light sticky-header" }, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, "Data creazione"),
                  _createElementVNode("th", null, "Città"),
                  _createElementVNode("th", null, "Numero immobile"),
                  _createElementVNode("th", null, "Indirizzo"),
                  _createElementVNode("th", null, "Cantiere"),
                  _createElementVNode("th", null, "Sup. comm.")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                (_ctx.list.data.length == 0)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_20, _cache[19] || (_cache[19] = [
                      _createElementVNode("td", {
                        colspan: "6",
                        class: "text-center text-muted py-4"
                      }, " Nessuna riga da mostrare ", -1)
                    ])))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list.data, (item) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    class: "pointer",
                    key: item.id,
                    onClick: ($event: any) => (_ctx.chooseRow(item))
                  }, [
                    _createElementVNode("td", null, _toDisplayString(item.createdOn), 1),
                    _createElementVNode("td", null, _toDisplayString(item.citta), 1),
                    _createElementVNode("td", null, _toDisplayString(item.numeroImmobile), 1),
                    _createElementVNode("td", null, _toDisplayString(item.indirizzo) + " " + _toDisplayString(item.numeroCivico), 1),
                    _createElementVNode("td", null, _toDisplayString(item.isStammobjekt != 0 ? 'Cantiere' : ''), 1),
                    _createElementVNode("td", null, _toDisplayString(item.superficieCommerciale) + " mq", 1)
                  ], 8, _hoisted_21))
                }), 128))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-sm btn-outline-primary me-2",
              disabled: _ctx.page == 1,
              onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.prev && _ctx.prev(...args)))
            }, "Prec.", 8, _hoisted_23),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.prevPages, (p) => {
              return (_openBlock(), _createElementBlock("button", {
                type: "button",
                class: "btn btn-sm btn-outline-secondary me-1",
                key: 'prev-'+p,
                onClick: ($event: any) => (_ctx.setPage(p))
              }, _toDisplayString(p), 9, _hoisted_24))
            }), 128)),
            _createElementVNode("button", _hoisted_25, _toDisplayString(_ctx.page), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nextPages, (p) => {
              return (_openBlock(), _createElementBlock("button", {
                type: "button",
                class: "btn btn-sm btn-outline-secondary ms-1",
                key: 'next-'+p,
                onClick: ($event: any) => (_ctx.setPage(p))
              }, _toDisplayString(p), 9, _hoisted_26))
            }), 128)),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-sm btn-outline-primary ms-2",
              disabled: _ctx.totalPages <= _ctx.page,
              onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.next && _ctx.next(...args)))
            }, "Succ.", 8, _hoisted_27)
          ])
        ])
      ])
    ])
  ]))
}